import axios, { AxiosResponse } from 'axios';
import { IRequestData, IResponseDataItem } from './find-deregistered-taxpayer.type';

export const url = '/services/isnaportalsync/open-api/taxpayer-individual-activity';

export const getDeregisteredTaxpayerInfo = (
    request: IRequestData
): Promise<AxiosResponse<IResponseDataItem[]>> => {
    return axios.get(`${url}`, { params: request });
};
